import { useEffect, useState } from 'react';
import { useAxios } from '../../../../Hooks';
import { useSelector } from 'react-redux';

const useDataEventDetails = (eventId) => {
    const [event, setEvent] = useState(null);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const { isLoading, error, sendRequest: fetchEventDetails } = useAxios();

    const getEventDetails = () => {
        fetchEventDetails(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url: isAuthenticated
                    ? `winnre/user/events/${eventId}`
                    : `/cms_service/events/${eventId}`,
                method: 'get'
            },
            (data) => {
                setEvent(data);
            }
        );
    };

    useEffect(() => {
        getEventDetails();
    }, [eventId]);

    return {
        event,
        isLoading
    };
};

export default useDataEventDetails;
